"use client"

// =============================================================================
// RecentRoutesTracker
//
// Renderless client component mounted once in app/layout.tsx. Subscribes to
// Next.js App Router pathname changes and feeds them into the bounded ring
// buffer in lib/recent-routes.ts. The buffer is read by lib/error-reporter.ts
// whenever an error is shipped to /api/log/frontend-error.
//
// Why a component (vs a hook in layout): layout.tsx is a server component, so
// we cannot call client hooks there. Wrapping the hook in a tiny client
// component keeps the layout server-side and the tracking client-side.
// =============================================================================

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { pushRoute } from "@/lib/recent-routes"
import { addBreadcrumb } from "@/lib/breadcrumbs"

export function RecentRoutesTracker(): null {
  const pathname = usePathname()
  useEffect(() => {
    pushRoute(pathname)
    // Same signal, two consumers: the "last-5 routes" summary stays for
    // backward-compat aggregations; the breadcrumb adds a timestamp so the
    // trail can be sorted across mixed sources (nav / http / ui).
    addBreadcrumb("nav", pathname)
  }, [pathname])
  return null
}
